// preload appConfig, clientTree and listViews of sections
import gql from 'graphql-tag'

import { fragment as clientTree } from 'gql/query/cashRegistersTree'
import { listProducts } from 'sections/product/gql/fragments'
import { listCategories } from 'sections/category/gql/fragments'
import { listUsers } from 'sections/user/gql/fragments'
import { listMedias } from 'sections/media/gql/fragments'
import { listCreditClients } from 'sections/creditClient/gql/fragments'
import { listLoyaltyCards } from 'sections/loyaltyCard/gql/fragments'
import { fragment as generalSettings } from 'sections/options/sections/GeneralSettings/gql/getAppConfig'
import { fragment as cashRegisters } from 'gql/query/listCashRegisters'

// Here you can see the enum of CA Web routes and theirs section numbers
// The same enum you can see by following path: ca-gql-api/packages/common-lib/directives/resolvers.js
// The authorization logic you can see by following path: ca-gql-api/packages/common-lib/directives/auth.js
// CAW_PRODUCT: '3',
// CAW_TEMPLATE: '4',
// CAW_EMPLOYEE: '5',
// CAW_MEDIA_CENTER: '6',
// CAW_CUSTOMERS_CREDIT: '12',
// CAW_DEGREES: '9',
// CAW_DEBIT_CARD: '13',
// CAW_STATISTICS: '11',
// CAW_MESSAGES: '14',
// CAW_OPTIONS: '1',

const initQuery = gql`
query initialize(
	$defaultLimit: Int!,
	$defaultParams: ListQueryArgs!,
	# Section flags
	$withProduct: Boolean = true,
	$withTemplate: Boolean = true,
	$withEmployee: Boolean = true,
	$withMediaCenter: Boolean = true,
	$withCustomersCredit: Boolean = true,
	$withDebitCard: Boolean = true,
	$includeOutOfOrder: Boolean = false
) {
	whoami {
		company {
			modules {
				cashassist {
				  isActive
				}
			}
		}
	}
	cashAssist {
		getAppConfigAdditional {
			priceLevels
			discountGroupNames
		}
		getAppConfig {
			...generalSettings
		maxPriceLevel
		priceLevelsLinkFA
		priceLevelsCafeLinkFA
		taraName
		mainCurrency
		e2nIntegrationActive
		creditCards
		cashRegisterGlobal {
			printerLocations {
					dbIndex
					value
				}
				pointsSystemName
				isActivePointsSystem
		}
		}

		getAppConfigAdditional {
			priceLevels
			discountGroupNames
		}

		...clientTree
		listProducts (filter: {isActive: true}, params: $defaultParams) @include(if: $withProduct) {
			...listProducts
		}
		listCategories(filter: {}, params: {
			sort: [{ field: "position", order: ASC }],
			cursors: { limit: $defaultLimit },
			limit: $defaultLimit
		}) @include(if: $withTemplate) {
			...listCategories
		}
		listUsers(filter: {}, params: $defaultParams) @include(if: $withEmployee){
			...listUsers
		}
		listMedia(filter: {}, params: $defaultParams) @include(if: $withMediaCenter) {
			...listMedias
		}
		listCreditClients(filter: {}, params: $defaultParams) @include(if: $withCustomersCredit) {
			...listCreditClients
		}
		listLoyaltyCards(filter: {}, params: $defaultParams) @include(if: $withDebitCard) {
			...listLoyaltyCards
		}
		listCashRegisters {
			...cashRegisterFields
		}
	}
}
${generalSettings}
${clientTree}
${listProducts}
${listCategories}
${listUsers}
${listMedias}
${listCreditClients}
${listLoyaltyCards}
${cashRegisters}
`

export default initQuery
